import { Timestamp } from '@angular/fire/firestore';
import { Dto, IDName } from '@damofire/data-commons';
import { Supplier } from './production-item.dto';

export enum LineItemWarnings {
  SHOULD_SPLIT_DBRS = 'SHOULD_SPLIT_DBRS',
  SHOULD_SPLIT_DRLDBRS = 'SHOULD_SPLIT_DRLDBRS',
  SHOULD_SPLIT_DRL = 'SHOULD_SPLIT_DRL',
}

export interface LineItemWarningDetail {
  model: string;
  numberOfProducts: number;
}

export const LINE_ITEM_WARNING_DETAILS: Record<LineItemWarnings, LineItemWarningDetail> = {
  [LineItemWarnings.SHOULD_SPLIT_DBRS]: { model: 'DBRS', numberOfProducts: 2 },
  [LineItemWarnings.SHOULD_SPLIT_DRLDBRS]: { model: 'DRLDBRS', numberOfProducts: 3 },
  [LineItemWarnings.SHOULD_SPLIT_DRL]: { model: 'DRL', numberOfProducts: 2 },
};

export interface SalesOrder extends Dto<string> {
  archived?: boolean;
  contact?: SalesOrderContact;
  customer?: IDName & {
    taxId?: string;
  };
  distributorName?: string;
  drawn?: {
    date: Timestamp | string;
    by: string;
  };
  description?: string;
  endDate?: Timestamp | string;
  endUser?: string;
  expectedShipDate?: Timestamp | string;
  incomplete?: boolean;
  internalId?: string;
  items?: ModelItem[];
  job?: string;
  language?: 'en' | 'fr';
  memo?: string;
  po?: string;
  pdfPath?: string;
  status?: string;
  salesOrderNumber?: string; // tranId straight from salesOrder in case MES needs it.
  quoteNumber?: string; // netsuite field createdFrom, if DNE we use salesOrderNumber (tranId)
  orderTrackingId?: string;
  redo?: string;
  hasMoberlyItems?: boolean;
  hasBoisbriandItems?: boolean;
}

export enum LINE_ITEM_LOCATIONS {
  BOISBRIAND = '5',
  MOBERLY = '6',
}

export interface SalesOrderModel extends Dto<string> {
  color?: string;
  drawing?: string; // path on bucket
  items?: ModelItem[]; // Only items related to this model
  model: string;
  expectedShipDate?: Timestamp | string;
  salesOrder: SalesOrder; // Partial salesOrder without items
  requestedBy?: string[]; // List of users who have requested this model, will use to prevent double sending
  qty: number; // model quantity set at generation of drawing.
  supplier?: Supplier;
  regroupedItems?: RegroupedItem;
}

export interface SalesOrderContact {
  name: string;
  email: string;
}

export interface ModelItem {
  _id?: string;
  line: number;
  item: number;
  displayName: string;
  shortName?: string;
  itemInternalId: string;
  qty: number;
  closed: boolean;
  color: string;
  description: string;
  rawDescription: string;
  mesId: string;
  damageLocation: string;
  dropShip: string;
  extraInfoField: boolean;
  selected?: boolean;
  location?: `${LINE_ITEM_LOCATIONS}`;
  warnings?: LineItemWarnings[];
}

export interface GridModelItem extends ModelItem {
  modelQty?: number;
}
export interface ShippedInformation {
  by?: string;
  supplier: string;
  trackingNumber: string;
  dateOfUpdate?: Timestamp;
  markedAsArchived?: boolean;
}

export enum SALES_ORDER_STATUS_TYPES {
  ARCHIVED = 'ARCHIVED',
  DRAWN = 'DRAWN',
  READY_TO_DRAW = 'READY_TO_DRAW',
  PRODUCTION = 'PRODUCTION',
  SHIPPED = 'SHIPPED',
  INSTALLED = 'INSTALLED',
}
export type NetsuiteProduct = Pick<ModelItem, 'displayName' | 'description' | 'qty'>;

export interface RegroupedItem {
  parentItems: ModelItem[];
  suggestions?: ModelItem[];
  manual?: NetsuiteProduct[];
}
